import { render, staticRenderFns } from "./PersonalDesignTestView.vue?vue&type=template&id=600bc4e6"
import script from "./PersonalDesignTestView.vue?vue&type=script&lang=ts"
export * from "./PersonalDesignTestView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports